import { Upload, Modal } from 'antd'
import uploadBigFile from '@/utils/uploadFile'
import { useState } from 'react'

let fileId_ = 0

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  }
);

const UploadBigFile = props => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const customProps = props.customProps || {}
  const fileList = props.fileList || []
  const fileFormat = props.fileFormat || []
  const maxFileSize = props.maxFileSize ? props.maxFileSize * 1024 * 1024 : 0

  const fileUrl = id => {
    return window.domainConfig.fileServer + '/' + id
  }

  const errorHandler = error => {
    if (typeof props.onError === 'function') {
      props.onError(error)
    }
  }

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  return (
    <div>
      <Upload
        onPreview={handlePreview}
        {...customProps}
        accept={
          Array.isArray(fileFormat)
            ? fileFormat
                .map(item => {
                  return item.substr(0, 1) === '.' ? item : `.${item}`
                })
                .join(',')
            : ''
        }
        progress={{
          strokeColor: {
            '0%': '#108ee9',
            '100%': '#87d068'
          },
          strokeWidth: 3,
          format: percent_ => percent_ && `${parseFloat(percent_.toFixed(2))}%`
        }}
        fileList={fileList}
        customRequest={async options => {
          if (props.noAllow) {
            return
          }

          const { file } = options
          const fl = file.name.split('.')
          if (fl.length >= 2 && !fileFormat.includes(file.name.split('.')[fl.length - 1])) {
            errorHandler('文件格式错误')
            return
          }

          if (maxFileSize > 0 && file.size > maxFileSize) {
            errorHandler('文件超过了最大值')
            return
          }
          const fileName = file.name
          fileId_ += 1
          const fileId = `upload${fileId_}`

          const fileUploading = (percent, status, url = '', file = {}) => {
            const fileObj = {
              uid: fileId,
              name: fileName,
              status: status,
              percent: percent,
              url: url,
              file
            }
            if (typeof props.onChange === 'function') {
              props.onChange(fileObj)
            }
            return fileObj
          }

          fileUploading(0, 'uploading')

          const res = await uploadBigFile(file, p => {
            fileUploading(p > 99 ? 99 : p, 'uploading')
          }).catch(error => {
            fileUploading(100, 'error')
            errorHandler(error && 'message' in error ? error.message : '上传错误')
            return Promise.reject(error)
          })
          fileUploading(100, 'done', fileUrl(res.id), {
            fileId: res.id,
            fileName: res.fileName,
            extension: res.extension,
            mime: res.mime
          })
        }}
        onRemove={file => {
          if (typeof props.onRemove === 'function') {
            props.onRemove(file)
          }
        }}
        onChange={({ file, fileList, event }) => {}}>
        {props.children}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={800}
      >
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </div>
  )
}

export default UploadBigFile
